/**
 * @module Footer
 * @description Site footer with nav links, contact info, investor link, and dashboard access.
 */

import React, { memo } from 'react';
import { Link } from 'react-router-dom';

const Footer = memo(function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="fl-footer" role="contentinfo">
      <div className="fl-footer__inner">
        <span className="fl-footer__copy">
          &copy; {year} FMFreeman INC. All Rights Reserved.
        </span>
        <div className="fl-footer__links">
          <div className="fl-footer__group" aria-label="Product links">
            <span className="fl-footer__group-label">Product</span>
            <Link to="/" className="fl-footer__link">Home</Link>
            <Link to="/paid-restrooms" className="fl-footer__link">Paid Restrooms</Link>
            <Link to="/pilot" className="fl-footer__link">Pilot Program</Link>
            <a href="https://dashboard.paidrestrooms.com" className="fl-footer__link" target="_blank" rel="noopener noreferrer">Dashboard</a>
          </div>
          <div className="fl-footer__group" aria-label="Company links">
            <span className="fl-footer__group-label">Company</span>
            <Link to="/investors" className="fl-footer__link">Investor Inquiries</Link>
            <Link to="/terms" className="fl-footer__link">Terms of Service</Link>
            <Link to="/privacy" className="fl-footer__link">Privacy Policy</Link>
            <Link to="/support" className="fl-footer__link">Support</Link>
          </div>
          <div className="fl-footer__group" aria-label="Support links">
            <span className="fl-footer__group-label">Support</span>
            <Link to="/contact" className="fl-footer__link">Contact</Link>
            <a href="mailto:team@flush-locks.com" className="fl-footer__link">team@flush-locks.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
